(function () {
function $d8f48c73be7235e1$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $fabd23f91d5c20a6$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $d8f48c73be7235e1$export$1e71eb4bef00f6b0)(target, key, source[key]);
        });
    }
    return target;
}


function $8527008305b3b513$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8527008305b3b513$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $8527008305b3b513$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}


function $ed167f82792fd0c4$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}


function $ca959b32573a749c$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $66e77502a3dcc0c5$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $802bff6cd21a9bd2$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $7af5190d3308f79c$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $802bff6cd21a9bd2$export$79e617b1955a2616)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $802bff6cd21a9bd2$export$79e617b1955a2616)(o, minLen);
}


function $3ab434014bf97dcd$export$fdf2a89c76341bbf(arr, i) {
    return (0, $ed167f82792fd0c4$export$e6256bf45c68d561)(arr) || (0, $ca959b32573a749c$export$2fd15edff6687200)(arr, i) || (0, $7af5190d3308f79c$export$a5be06335b3a083c)(arr, i) || (0, $66e77502a3dcc0c5$export$60dbc22abd7da546)();
}



function $c346e2c6948667cb$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $802bff6cd21a9bd2$export$79e617b1955a2616)(arr);
}


function $d8c1c60a00fd7b05$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $1ea3b6fa3b933d9e$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $b5358b88e8832525$export$1b5e630bc3aea29f(arr) {
    return (0, $c346e2c6948667cb$export$7e0947b5ad3404e2)(arr) || (0, $d8c1c60a00fd7b05$export$1eb58a6e75231000)(arr) || (0, $7af5190d3308f79c$export$a5be06335b3a083c)(arr) || (0, $1ea3b6fa3b933d9e$export$e6f3c4780d19eb2b)();
}


var $352554f0283c7491$var$state = $352554f0283c7491$var$initialState();
var $352554f0283c7491$var$highScore = localStorage["high-score"] || 0;
//
// function updateStylesheets() {
//     const element = document.createElement("style");
//     element.id = "color-css";
//
//     document.querySelector('head').append(element);
//     const stylesheet = document.styleSheets[document.styleSheets.length - 1];
//     // hsl
//     let r = [];
//     for (let i = 0; i < 14; ++i) {
//         const n = Math.pow(2, i);
//         //const color = `lch( ${95 - 5 * i}% ${50 + i * 10} ${140 - i * 6} )`;
//          const color = `lch( ${25 + 5 * i}% ${50 + i * 10} ${140 - i * 6} )`;
//
//         const rule = `.value-${n} { background: ${color}; }`;
//         r.push(`  --color-${i}: ${color};`);
//         stylesheet.insertRule(rule);
//     }
//     console.log(r.join('\n'));
// }
//
// updateStylesheets();
document.onkeydown = function(event) {
    if (!$352554f0283c7491$var$state.playing) return;
    switch(event.code){
        case "ArrowLeft":
            $352554f0283c7491$var$moveLeft();
            break;
        case "ArrowUp":
            $352554f0283c7491$var$moveUp();
            break;
        case "ArrowRight":
            $352554f0283c7491$var$moveRight();
            break;
        case "ArrowDown":
            $352554f0283c7491$var$moveDown();
            break;
        default:
    }
};
var $352554f0283c7491$var$touchX = 0;
var $352554f0283c7491$var$touchY = 0;
document.addEventListener("touchstart", function(e) {
    $352554f0283c7491$var$touchX = e.changedTouches[0].screenX;
    $352554f0283c7491$var$touchY = e.changedTouches[0].screenY;
});
document.addEventListener("touchend", function(e) {
    var endX = e.changedTouches[0].screenX;
    var endY = e.changedTouches[0].screenY;
    console.log("SWIPE !", $352554f0283c7491$var$touchX, endX, $352554f0283c7491$var$touchY, endY);
    if (Math.abs($352554f0283c7491$var$touchX - endX) > Math.abs($352554f0283c7491$var$touchY - endY)) {
        // x swipe
        if ($352554f0283c7491$var$touchX - endX > 50) $352554f0283c7491$var$moveLeft();
        if (endX - $352554f0283c7491$var$touchX > 50) $352554f0283c7491$var$moveRight();
    } else {
        if ($352554f0283c7491$var$touchY - endY > 50) $352554f0283c7491$var$moveUp();
        else if (endY - $352554f0283c7491$var$touchY > 50) $352554f0283c7491$var$moveDown();
    }
});
document.getElementById("restart").addEventListener("click", function() {
    $352554f0283c7491$var$resetBoard();
});
function $352554f0283c7491$var$orderCells(cells) {
    cells.sort(function(a, b) {
        if (a.left === b.left) return a.top - b.top;
        else return a.left - b.left;
    });
}
function $352554f0283c7491$var$makeCell(left, top, value) {
    var element = document.createElement("div");
    element.innerText = value + "";
    element.className = "cell top-".concat(top, " left-").concat(left, " value-").concat(value, " ");
    return element;
}
function $352554f0283c7491$var$addRandomCell(state) {
    var _loop = function(i) {
        var _loop = function(j) {
            var present = state.cells.filter(function(c) {
                return c.top === j && c.left === i;
            }).length > 0;
            if (!present) free.push([
                i,
                j
            ]);
        };
        for(var j = 0; j < 4; ++j)_loop(j);
    };
    var free = [];
    for(var i = 0; i < 4; ++i)_loop(i);
    var chosen = Math.floor(Math.random() * free.length);
    var _free_chosen = (0, $3ab434014bf97dcd$export$fdf2a89c76341bbf)(free[chosen], 2), left = _free_chosen[0], top = _free_chosen[1];
    var r = Math.random();
    var value = 1;
    if (r < 0.1) value = 4;
    else if (r < 0.4) value = 2;
    // console.log("Adding random element at",left, top,"with value",value);
    // console.log("Existing values are", state.cells);
    var element = $352554f0283c7491$var$makeCell(left, top, value);
    var cell = {
        element: element,
        left: left,
        top: top,
        value: value
    };
    var newState = (0, $8527008305b3b513$export$4fa2f4023c9cbda5)((0, $fabd23f91d5c20a6$export$581ff339ea0ba762)({}, state), {
        cells: (0, $b5358b88e8832525$export$1b5e630bc3aea29f)(state.cells).concat([
            cell
        ])
    });
    $352554f0283c7491$var$orderCells(newState.cells);
    return newState;
}
function $352554f0283c7491$var$initialState() {
    var state = {
        cells: [],
        removed: [],
        playing: true,
        score: 0
    };
    for(var i = 0; i < 4; ++i)state = $352554f0283c7491$var$addRandomCell(state);
    console.log("Initial state", state);
    return state;
}
function $352554f0283c7491$var$resetBoard() {
    $352554f0283c7491$var$state = $352554f0283c7491$var$initialState();
    document.getElementById("game").replaceChildren();
    $352554f0283c7491$var$refreshBoard($352554f0283c7491$var$state);
}
function $352554f0283c7491$var$getRow(state, row, reverse) {
    var result = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = state.cells[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var cell = _step.value;
            if (cell.top === row) result.push(cell);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (reverse) result.reverse();
    return result;
}
function $352554f0283c7491$var$getColumn(state, column, reverse) {
    var result = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = state.cells[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var cell = _step.value;
            if (cell.left === column) result.push(cell);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (reverse) result.reverse();
    return result;
}
function $352554f0283c7491$var$move(oldState, direction) {
    var extraScore = 0;
    var getter = direction == "up" || direction == "down" ? $352554f0283c7491$var$getColumn : $352554f0283c7491$var$getRow;
    var reverse = direction == "up" || direction == "left" ? false : true;
    var changingField = direction == "up" || direction == "down" ? "top" : "left";
    var newCells = [];
    var deleted = [];
    for(var i = 0; i < 4; ++i){
        // console.log("Processing row/column", i);
        var merged = false;
        var elements = getter(oldState, i, reverse);
        // console.log("Elements of", i, ":", elements);
        var result = [];
        for(var j = 0; j < elements.length; ++j)if (j > 0 && !merged && elements[j].value === elements[j - 1].value) {
            var cur = result.length - 1;
            // console.log("Merging element", j, "into previous because both have value", elements[j].value);
            merged = true;
            // remove the previous
            result[cur][changingField] = reverse ? 3 - cur : cur;
            deleted.push(result[cur]);
            result[cur] = (0, $fabd23f91d5c20a6$export$581ff339ea0ba762)({}, elements[j]);
            result[cur].value *= 2;
            extraScore += result[cur].value;
        } else {
            // console.log("Copying element", j, elements[j]);
            merged = false;
            result.push((0, $fabd23f91d5c20a6$export$581ff339ea0ba762)({}, elements[j]));
        }
        for(var j1 = 0; j1 < result.length; ++j1){
            //            console.log("Changing value of", result[j], "to", reverse ? 3 - j : j);
            result[j1][changingField] = reverse ? 3 - j1 : j1;
            newCells.push(result[j1]);
        }
    }
    $352554f0283c7491$var$orderCells(newCells);
    return (0, $8527008305b3b513$export$4fa2f4023c9cbda5)((0, $fabd23f91d5c20a6$export$581ff339ea0ba762)({}, oldState), {
        cells: newCells,
        removed: deleted,
        score: oldState.score + extraScore
    });
}
function $352554f0283c7491$var$sameState(state1, state2) {
    if (state1.cells.length !== state2.cells.length) return false;
    for(var i = 0; i < state1.cells.length; ++i){
        var c1 = state1.cells[i];
        var c2 = state2.cells[i];
        if (c1.top !== c2.top || c1.left != c2.left || c1.value != c2.value) return false;
    }
    return true;
}
function $352554f0283c7491$var$loop(oldState, direction) {
    var newState = $352554f0283c7491$var$move(oldState, direction);
    if ($352554f0283c7491$var$sameState(oldState, newState)) {
        console.log("State", oldState, "and", newState, "are the same, ignoring");
        return;
    }
    newState = $352554f0283c7491$var$addRandomCell(newState);
    if ($352554f0283c7491$var$isGameOver(newState)) {
        newState.playing = false;
        $352554f0283c7491$var$highScore = Math.max($352554f0283c7491$var$highScore, newState.score);
        localStorage["high-score"] = $352554f0283c7491$var$highScore;
    }
    $352554f0283c7491$var$refreshBoard(newState);
    $352554f0283c7491$var$state = newState;
}
function $352554f0283c7491$var$computeScore(state) {
    //return state.cells.map( c => c.value ).reduce( (a,b) => a+b );
    return state.score;
}
function $352554f0283c7491$var$refreshBoard(state) {
    var board = document.getElementById("game");
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var c = _step.value;
            c.element.textContent = c.value + "";
            if (c.element.parentElement !== board) {
                c.element.className = "invisible cell top-".concat(c.top, " left-").concat(c.left, " value-").concat(c.value, " ");
                board.appendChild(c.element);
                setTimeout(function() {
                    c.element.className = "cell top-".concat(c.top, " left-").concat(c.left, " value-").concat(c.value, " ");
                }, 0);
            } else c.element.className = "cell top-".concat(c.top, " left-").concat(c.left, " value-").concat(c.value, " ");
        };
        for(var _iterator = state.cells[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        var _loop1 = function() {
            var d = _step1.value;
            d.element.className = "cell top-".concat(d.top, " left-").concat(d.left, " value-").concat(d.value, " removed");
            setTimeout(function() {
                return d.element.remove();
            }, 5000);
        //            d.element.remove();
        };
        for(var _iterator1 = state.removed[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true)_loop1();
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    var score = $352554f0283c7491$var$computeScore(state);
    document.getElementById("score").innerText = "" + score;
    document.getElementById("high-score").innerText = "" + $352554f0283c7491$var$highScore;
    if (state.playing) {
        document.getElementById("end").style.visibility = "hidden";
        document.getElementById("result").innerText = "";
    } else {
        document.getElementById("result").innerText = "Game Over !";
        document.getElementById("end").style.visibility = "visible";
    }
}
function $352554f0283c7491$var$isGameOver(state) {
    if (state.cells.length !== 16) return false;
    var value = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = state.cells[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var cell = _step.value;
            value["".concat(cell.left, "-").concat(cell.top)] = cell.value;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    for(var i = 0; i < 4; ++i)for(var j = 0; j < 4; ++j){
        var x1 = value["".concat(i, "-").concat(j)];
        var x2 = value["".concat(i + 1, "-").concat(j)];
        var x3 = value["".concat(i, "-").concat(j + 1)];
        // note we may go out of bounds here but it works in
        // our favor
        if (x1 === x2 || x1 === x3) return false;
    }
    return true;
}
function $352554f0283c7491$var$moveUp() {
    $352554f0283c7491$var$loop($352554f0283c7491$var$state, "up");
}
function $352554f0283c7491$var$moveDown() {
    $352554f0283c7491$var$loop($352554f0283c7491$var$state, "down");
}
function $352554f0283c7491$var$moveLeft() {
    $352554f0283c7491$var$loop($352554f0283c7491$var$state, "left");
}
function $352554f0283c7491$var$moveRight() {
    $352554f0283c7491$var$loop($352554f0283c7491$var$state, "right");
}
$352554f0283c7491$var$resetBoard();

})();
//# sourceMappingURL=index.24333168.js.map
